export const apiConfig = {
  apiUrl: 'https://demoapi.poko.com.pl'
};
